import React from "react";
import "../surveyAdherence.css";
import AdminNavbar from "../../components/AdminNavbar";
import {Col, Container, Jumbotron, Row,} from "react-bootstrap";
// import AReportTable from "./AReportTable";
// import BReportTable from "./BReportTable";
import BReportTable004A from "./BReportTable004A";
import AnotherReportsListSidebar from "./AnotherReportsListSidebar";

// import AsmallerReportTable from "./AsmallerReportTable";
    // const query = firestore.collection("analytics/reports/reportPages");
    // const [reportPages, reportPagesLoading, reportPagesError] = useCollection(query, {
        // snapshotListenOptions: {includeMetadataChanges: true},
    // });
// const query = firestore.collection("analytics").doc("kpi_summary")
const A004Pros = (props) => {
 return (<>
        <AdminNavbar/>
        <Jumbotron>
        <Container fluid={true} style={{paddingBottom: "30px"}}>
                <Row>
                    <Col>
                        <h1>004 Participants</h1>
                    </Col>
                </Row>
            </Container>
        </Jumbotron>
        <AnotherReportsListSidebar style={{ paddingRight: "50px"}}/>
        {/* <Container fluid={true} style={{backgroundColor: "white"}}>

            <div className="sidenav">
            <p><Link className="TitleD" style={{paddingLeft: "20px"}} to="/004/sites">
                Sites</Link></p>
               <p><Link className="TitleD" style={{paddingLeft: "20px"}} to="/004/pros">
                PROs</Link></p>

            </div>
             </Container> */}
        <Container fluid={true} style={{backgroundColor: "white", paddingLeft: "50px"}}>
            <div className="article">
            <p className="TitleC">PROs</p>
            <BReportTable004A tableKey={"pros004"}></BReportTable004A>
                </div>
        </Container>
        {/* <Container fluid={true} style={{backgroundColor: "white"}}>
            <div className="article">
            <AReportTable tableKey={"engagement_kpis"}></AReportTable>
                </div>
        </Container>
        <Container fluid={true} style={{backgroundColor: "white"}}>
            <div className="article">
            <AReportTable tableKey={"lesson_kpis"}></AReportTable>
                </div>
        </Container>
        <Container fluid={true} style={{backgroundColor: "white"}}>
            <div className="article">
            <AsmallerReportTable tableKey={"pro_adherence_kpis"}></AsmallerReportTable>
                </div>
        </Container> */}

</>);

};

export default A004Pros;

